import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setConfiguration } from '../../configuration/actions'
import { setTradeIn } from '../actions'

import Distributor from './Distributor'

const mapStateToProps = state => ({
  wizards: state.wizards,
  tradeIn: state.tradeIn,
  configuration: state.configuration
})

const mapDispatchToProps = {
  setWizards,
  setTradeIn,
  setConfiguration
}

export default connect(mapStateToProps, mapDispatchToProps)(Distributor)
